import { render } from "./MessageIn.vue?vue&type=template&id=8d32dc3c"
import script from "./MessageIn.vue?vue&type=script&lang=ts"
export * from "./MessageIn.vue?vue&type=script&lang=ts"
script.render = render

export default script